import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import * as userSelectors from '../../selectors/userSelectors';
import * as exportProjectImagesSelectors from '../../selectors/exportProjectImagesSelectors';
import { Button, IconButton, Paper, Typography } from '@material-ui/core';

const ExportImagesConfirmationModal = ({
    show,
    onClose,
    selection,
    currentUser,
    jobCount,
    classes,
}) => {
    if (!show || !selection) {
        return null;
    }

    const exportTables = selection.exportTables;
    const exportCharts = selection.exportCharts;
    const format = selection.format;
    const formatLabel = format ? format.toUpperCase() : 'IMAGE';

    const parts = [];
    if (exportTables) parts.push('tables');
    if (exportCharts) parts.push('charts');

    const selectionText =
        parts.length === 0
            ? 'your selection'
            : parts.length === 1
                ? `${jobCount} ${parts[0]}`
                : `${jobCount} ${parts[0]} and ${parts[1]}`;

    const userEmail = currentUser ? currentUser.email : '';
    const emailText = userEmail || 'your account email';

    return (
        <div className={classes.container}>
            <Paper className={classes.modal}>
                <div className={classes.header}>
                    <Typography className={classes.title} variant="title">
                        Export started
                    </Typography>
                    <IconButton
                        aria-label="Close modal"
                        onClick={onClose}
                    >
                        x
                    </IconButton>
                </div>

                <div className={classes.content}>
                    <Typography variant="body1" className={classes.message}>
                        We&apos;re generating {formatLabel} exports for your{' '}
                        {selectionText}. You will receive an email at{' '}
                        <strong>{emailText}</strong> when your images are ready.
                    </Typography>
                </div>

                <div className={classes.footer}>
                    <Button
                        onClick={onClose}
                        variant="contained"
                        color="primary"
                    >
                        OK
                    </Button>
                </div>
            </Paper>
            <div
                className={classes.background}
                onClick={onClose}
            />
        </div>
    );
};

ExportImagesConfirmationModal.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    selection: PropTypes.shape({
        exportTables: PropTypes.bool,
        exportCharts: PropTypes.bool,
        format: PropTypes.string,
    }),
    classes: PropTypes.object.isRequired,
    currentUser: PropTypes.object,
    jobCount: PropTypes.number,
};

ExportImagesConfirmationModal.defaultProps = {
    show: false,
    selection: null,
    currentUser: null,
    jobCount: 0,
};

const style = ({ palette }) => ({
    container: {
        width: 0,
        height: 0,
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '20px',
        borderBottom: `1px solid ${palette.background.gray2Color}`,
    },
    title: {
        lineHeight: '1.8em',
    },
    content: {
        padding: '20px',
    },
    message: {
        lineHeight: 1.5,
    },
    footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '15px 20px',
        borderTop: `1px solid ${palette.background.gray2Color}`,
    },
    background: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        background: 'rgba(0, 0, 0, 0.5)',
    },
    modal: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        width: '50%',
        maxWidth: '450px',
        minWidth: '300px',
        transform: 'translate(-50%, -50%)',
        zIndex: 128,
    },
});

const mapStateToProps = state => ({
    currentUser: userSelectors.getCurrentUser(state),
    jobCount: exportProjectImagesSelectors.getJobCount(state),
});

export default connect(mapStateToProps)(injectSheet(style)(ExportImagesConfirmationModal));



// WEBPACK FOOTER //
// ./src/components/modals/ExportImagesConfirmationModal.js